import { Tag, Typography } from '@components';
import { PackTemplate } from '@interfaces';
import { ListComponent } from '@utils';
import React from 'react';
import { CheckCircle, ChevronsRight, PlusSquare, Trash2 } from 'react-feather';

interface BaseProps {
  pack: PackTemplate;
  selected?: boolean;
  assignable?: boolean;
  informational?: boolean;
}

interface RemovableProps extends BaseProps {
  removable: true;
  onRemove: (packId: string) => void;
}

interface NonRemovableProps extends BaseProps {
  removable?: false;
  onRemove?: never;
}

type Props = RemovableProps | NonRemovableProps;

export const AssetPackDetail = ({
  pack,
  selected,
  removable,
  onRemove,
  assignable,
  informational = true,
}: Props) => {
  const tagStyle = {
    LICENSE: 'toegewezen',
    Werkstation: 'neutralcolored',
    Laptop: 'nieuw',
    Computer: 'nieuw',
    Desktop: 'toegewezen',
    PRODUCT: 'nieuw',
  };

  return (
    <div
      className={`relative p-4 border h-full rounded min-h-24 ${selected ? 'border-blue-600' : ''} group`}
    >
      <div className="grid grid-cols-2">
        <Typography tag="span" type="small">
          <Tag style={tagStyle[pack.PackType]} label={pack.PackType} />
        </Typography>
        <div className="justify-self-end">
          {selected ? <CheckCircle className="text-blue-600" size={16} /> : ''}
        </div>
      </div>

      <div className="mt-4">
        <Typography tag="h2" type="semibold">
          {pack.PackName}
        </Typography>
        {informational && (
          <div className="mt-2">
            <ul className="max-w-md space-y-1 text-body list-inside">
              <ListComponent
                data={pack.PackDetails.products}
                renderItem={(item) => (
                  <li
                    className="grid grid-cols-[auto,1fr] items-start gap-x-2"
                    key={item.name}
                  >
                    <div className="flex items-center h-5">
                      <ChevronsRight size={14} className="text-blue-400" />
                    </div>
                    <Typography tag="p" type="small">
                      {item.name}
                    </Typography>
                  </li>
                )}
              />
            </ul>
          </div>
        )}
      </div>

      {removable && (
        <button className="absolute inset-0 bg-red-200 bg-opacity-80 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <div
            className="px-4 py-2 text-red-500"
            onClick={() => onRemove(pack.SK)}
          >
            <Trash2 size={24} />
          </div>
        </button>
      )}
      {assignable && (
        <button className="absolute inset-0 bg-blue-200 bg-opacity-80 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="px-4 py-2 text-blue-800">
            <PlusSquare size={24} />
          </div>
        </button>
      )}
    </div>
  );
};

export default AssetPackDetail;
